import React from 'react';
import './WidthContainer.css';

interface IWidthContainerProps {}

export const WidthContainer: React.FC<IWidthContainerProps> = props => {
    return <div style={{ maxWidth: '100%', overflow: 'clip' }}><div className="WidthContainer">{props.children}</div></div>;
};
